export default {
  profile: (state, getters) => (getters.isLoggedIn ? state.profile : {}),
  addresses: state => state.addresses,
  isLoggedIn: state => !!state.token && state.token !== 'undefined',
  isUserActive: (state, getters) => {
    return getters.profile ? getters.profile.is_active : false
  },
  isNewClient: state => state.profile.activityStatus === 'new',
  isOldClient: state => state.profile.activityStatus === 'old',
  token: state => state.token,
  showOnboardings: state => state.showOnboardings,
  getFaq: state => state.faq,
  menuPlans: state => state.menu_plans,
  isDemoModeEnabled: state => state.demo_mode,
  unauthorizedImtData: state => state.unauthorizedImtData,
  preloadedMenus: state => state.preloadedMenus,
}
